import { render, staticRenderFns } from "./WishlistAssign.vue?vue&type=template&id=5731d021&scoped=true"
import script from "./WishlistAssign.vue?vue&type=script&lang=js"
export * from "./WishlistAssign.vue?vue&type=script&lang=js"
import style0 from "./WishlistAssign.vue?vue&type=style&index=0&id=5731d021&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5731d021",
  null
  
)

export default component.exports